export var MAX_SEARCH_QUERY_LENGTH = 43;
//# sourceMappingURL=constants.js.map